module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"chartHeaderTooltip":"The chart shows values for the minimum and maximum price, as well as deviations from the average price."}}')
  delete Component.options._Ctor
}
